<template>
    <!-- 免费试用弹窗 -->
    <div id="freeTrialModal" class="buy_modal_overlay display-none fixed items-center justify-center"
        :class="{ show: purchaseStore.freeTrialVisible }" @click.self="purchaseStore.closeFreeTrial()">
        <div class="buy_modal_card free_trial_card overflow-hidden">
            <div class="buy_modal_head d-flex-y">
                <div class="buy_modal_product">
                    <div class="buy_modal_ico">🎁</div>
                    <div>
                        <div class="buy_modal_name">AI + Office 免费试用</div>
                        <div class="buy_modal_sub">5天全功能体验</div>
                    </div>
                </div>
            </div>
            <div class="buy_modal_body">
                <div class="free_trial_panel">
                    <div class="free_trial_panel_title f14 mb10">🎉 免费试用包含：</div>
                    <div class="free_trial_grid">
                        <div v-for="feature in FREE_TRIAL_FEATURES" :key="feature"
                            class="free_trial_feature_item d-flex-y f13">
                            <span class="free_trial_feature_check b">✓</span>{{ feature }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="buy_modal_foot free_trial_foot flex justify-center">
                <button id="freeTrialConfirmBtn" class="buy_modal_confirm free_trial_confirm bn b pointer w-full"
                    @click="purchaseStore.confirmFreeTrial()">
                    ✅ 安装完成
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const purchaseStore = usePurchaseStore();

const FREE_TRIAL_FEATURES = ref(['Office 全套应用', 'AI PPT 成稿', '数据分析 AI', 'PPT 一键成稿', '1TB 云存储', '全平台同步']);
</script>

<style lang="less" scoped>
.free_trial_card {
    max-width: 480px;
}

.free_trial_panel {
    background: linear-gradient(135deg, rgba(255, 140, 0, .1), rgba(255, 200, 0, .06));
    border: 1.5px solid #FFB340;
    border-radius: 12px;
    padding: 18px 20px;
}

.free_trial_panel_title {
    font-weight: 800;
    color: #E05C00;
}

.free_trial_grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
}

.free_trial_feature_item {
    color: var(--text);
    gap: 6px;
}

.free_trial_feature_check {
    color: var(--green);
}

.free_trial_foot {}

.free_trial_confirm {
    background: linear-gradient(135deg, #FF6B35, #E05C00);
    max-width: 280px;
}
</style>
